import {findSection, findCard} from '../DashboardCommon/dashboardCards';

export const LEARNING_PROGRESS_SECTION_CODE = 'S_5';

/**
 * Whether the learner has a learning program linked, read from the Individual
 * dashboard's S_5 section: 'linked' | 'none' | 'unknown' (no data / no S_5).
 * Reads the card `status` (ok | none) rather than values: a suppressed KPI is still 'ok'.
 */
export const learningProgramPresence = (dashboardData) => {
    if (!findSection(dashboardData, LEARNING_PROGRESS_SECTION_CODE)) return 'unknown';
    const programs = findCard(dashboardData, LEARNING_PROGRESS_SECTION_CODE, 'C_5');
    const statuses = [programs, findCard(dashboardData, LEARNING_PROGRESS_SECTION_CODE, 'C_2')].map((c) => c?.status);
    if (statuses.includes('ok')) return 'linked';
    if (statuses.includes('none')) return 'none';
    // Older cards without a status: any row in the programs table.
    const rows = Math.max(0, ...(programs?.table_objects || []).map((col) => (col.values || []).length));
    return rows > 0 ? 'linked' : 'none';
};
